// @internal
export function isUndefined(value) {
    return value === undefined;
}
